import api from '@/helpers/api'

const API_READ = `/api/client/member-voucher/`
const API_REDEEM = `/api/client/redeem`
const API_CANCELLATION = `/api/client/cancellation`


export default {
    namespaced: true,
    state: {
        status: '',
        voucher: [],
        branches: [],
        errMessage: '',
        meta: {
            page: 1,
            limit: 10,
            total: 1
        },
        filter: {}
    },
    mutations: {
        request(state) {
            state.status = "Loading"
        },
        success(state) {
            state.status = "Success"
        },
        error(state, { message }) {
            state.status = "Error",
                state.errMessage = message
        },
        read(state, { voucher }) {
            state.voucher = [...voucher]
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        read_single_success(state, { voucher }) {
            state.voucher = voucher
        },
        setBranches(state, { branches }) {
            state.branches = branches;
        },
        add_filter(state, { filter }) {
            state.filter = filter;
        },
    },
    actions: {
        read({ commit, state }) {
            commit('request');

            const { meta } = state
            const { filter } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter })
                    .then((result) => {
                        commit('success');
                        commit('read', { voucher: result.data.data.vouchers });
                        commit('setBranches', { branches: result.data.data.branches });
                        commit('switch_page', { meta: { ...result.data.data.meta } });

                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        read_single({ commit }, id) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}${id}`)
                    .then((result) => {
                        commit('success')
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },
        redeem({ commit }, { data }) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('post', API_REDEEM, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        },
        cancellation({ commit }, { data }) {
            commit('request');
            return new Promise((resolve, reject) => {
                api.request('post', API_CANCELLATION, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    });
            });
        }
    },
    getters: {
        voucher: () => (state) => state.voucher,
        branches: state => state.branches,
    }
}